import React, { Fragment, useState } from "react";
import Parser from "application/components/parser";
import { clone, isNil } from "ramda";
import GarmentInformation from "./garment-information";
import GarmentArrangement from "./garment-arrangement";
import { translate } from "application/functions";
import returnFilter from "module/functions/returnFilter";

const Garment = (props) => {
  const {
    form,
    register,
    setSelectValue,
    defaultValue,
    errors,
    index,
    deleteItem,
    indexToShow,
    setArrangementsPrice,
    setArrangementsPriceWithoutDiscount,
    setArrangementsDiscount,
    setOnFocus,
    windowSize,
    isMobileBrowser,
  } = props;

  const jPath = `garment[${index}].garment`;

  const initialOptions = form.garment.sf.arrangement_group.sf.arrangement.selOptions;

  const [optionsAllowed, setOptionsAllowed] = useState([]);

  const removeDuplicates = (initialOptions, op) => {
    const duplicatedOptions = [];
    const filteredOptions = initialOptions.filter((option) => {
      const optionKey = option.key;
      const splitOption = optionKey.split(":");
      if (splitOption.length === 1 || (splitOption[1] && splitOption[1].trim().includes(op))) {
        const prevOption = splitOption[0].trim();
        const option = prevOption.split("-")[0].trim();
        splitOption.length === 2 && duplicatedOptions.push(option);
        return true;
      }
      return false;
    });
    const result = filteredOptions.filter((option) => {
      const optionLength = option.key.split(":").length;
      const splitOption = option.key.split("-")[0].trim();
      if (
        (optionLength === 1 && !duplicatedOptions.includes(splitOption)) ||
        (optionLength === 2 && option.key.includes(op))
      ) {
        return true;
      } else {
        return false;
      }
    });
    return result;
  };

  const updateOptionsAllowed = (option) => {
    let optionsToFilter;
    if (isNil(option)) {
      optionsToFilter = [];
    } else {
      const forFilter = returnFilter(option);
      const fixedOptions = removeDuplicates(initialOptions, option);
      optionsToFilter = clone(fixedOptions);
      optionsToFilter = optionsToFilter.filter(function (obj) {
        return !forFilter.some((substring) => obj.key.toLowerCase().includes(substring.toLowerCase()));
      });
    }
    setOptionsAllowed(optionsToFilter);
  };

  return (
    <Fragment>
      <div className="form__form-body" style={{ display: isNil(indexToShow) ? "none" : "block" }}>
        {index !== 0 && (
          <div className="journey__title-container">
            <Parser className={"form__form-body-title"} text={`${translate("product")} ${indexToShow + 1}`} />

            <div className="journey__delete-icon" onClick={deleteItem}>
              {translate("product.delete")}
            </div>
          </div>
        )}
        <GarmentInformation
          form={form}
          register={register}
          setSelectValue={setSelectValue}
          errors={errors}
          jPath={jPath}
          updateOptionsAllowed={updateOptionsAllowed}
          setOnFocus={setOnFocus}
        />
        <GarmentArrangement
          form={form}
          register={register}
          setSelectValue={setSelectValue}
          defaultValue={defaultValue}
          errors={errors}
          jPath={jPath}
          setArrangementsPrice={setArrangementsPrice}
          setArrangementsPriceWithoutDiscount={setArrangementsPriceWithoutDiscount}
          setArrangementsDiscount={setArrangementsDiscount}
          optionsAllowed={optionsAllowed}
          setOnFocus={setOnFocus}
          windowSize={windowSize}
          isMobileBrowser={isMobileBrowser}
          isHidden={isNil(indexToShow)}
        />
      </div>
    </Fragment>
  );
};

export default Garment;
